@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (AccessAllowed && pageReady) {
  <div class="p-3 flex flex-column flex-auto cf-page" [class.cf-compact]="isMobile">
    <div>
      <div class="text-900 font-medium text-xl mb-3"><h3>Resource</h3></div>
      <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
        <span class="pi pi-info-circle" style="margin-right:2px;"></span>
        Define your resource here.  Resources can also be composed from other resources.  For example you may have a resource called Trainer 1 and another called Trainer 2.  You could then create a resource called Paddleboard training which is made up of trainer 1 and Trainer 2.  When this resource is used it would block out trainer 1 and trainer 2.
      </p>
      <div class="surface-card p-4 shadow-2 border-round">
        <div class="grid formgrid p-fluid">
          <app-tabview [style]="{'width':'100%'}" [(activeIndex)]="activeIndex">
            <app-tabpanel header="Resource Details" leftIcon="pi pi-clone" >
              <div class="field mb-4 col-12">
                <label for="resourcename" class="font-medium">Resource Name</label>
                <input [(ngModel)]="Resource.name" id="resourcename" type="text" [ngStyle]="{'border-color': (resourceNameValid==false) ? '#FF0000':''}" pInputText>
              </div>
              @if (!resourceNameValid) {
                <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter an Resource name.</div>
              }
              <div class="field mb-4 col-12">
                <label for="useclasses" class="font-medium">Resource is made up of other resources</label>
                <p-selectbutton id="usesubresources" [style]="{'width': '150px'}" [options]="stateOptionsRes" [(ngModel)]="Resource.isresourcecontainer" (onOptionClick)="ContainerClick($event)"></p-selectbutton>
              </div>
              <div class="field mb-4 col-12">
                <label for="exclusive" class="font-medium">Exclusive</label>
                <p-selectbutton id="exclusive" [style]="{'width': '150px'}" [options]="stateOptions" [(ngModel)]="Resource.exclusive" ></p-selectbutton>
              </div>
              <!-- Show on Day Sheet used to be set here too; it now comes from the Daysheet Resource
              Order page, and the saved value still goes back unchanged on save. -->
              <div class="field mb-4 col-12">
                <label for="showinitinerary" class="font-medium">Show on Itinerary</label>
                <p-selectbutton id="showinitinerary" [style]="{'width': '150px'}" [options]="stateOptionsRes" [(ngModel)]="Resource.showinitinerary" ></p-selectbutton>
              </div>
              <div class="field mb-4 col-12">
                <label for="showonbooking" class="font-medium">Show on lists of bookings</label>
                <p-selectbutton id="showonbooking" [style]="{'width': '150px'}" [options]="stateOptions" [(ngModel)]="Resource.showonbooking" ></p-selectbutton>
              </div>
              <div class="field mb-4 col-12">
                <label for="daysheetinterval" class="font-medium">Day Sheet Interval in minutes (0 uses the venue default)</label>
                <p-inputnumber id="daysheetinterval" [style]="{'width': '300px'}" [(ngModel)]="Resource.daysheetinterval" [showButtons]="true" max="240" min="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
              </div>
              <!-- <div class="field mb-4 col-12">
              <label for="cansplit" class="font-medium">Can Split</label>
              <p-selectbutton id="cansplit" [style]="{'width': '150px'}" [options]="stateOptionsRes" [(ngModel)]="Resource.cansplit" ></p-selectbutton>
            </div> -->
            <div class="field mb-4 col-12">
              <label for="concurrentUses" class="font-medium">Capacity/Concurrent Uses</label>
              <p-inputnumber id="concurrentUses" [style]="{'width': '300px'}" [ngModel]="Resource.concurrentUses== null ? 0: Resource.concurrentUses" (ngModelChange)="Resource.concurrentUses = $event" [showButtons]="true" max="100000" min="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
            </div>
            @if (!resourceConcurrentValid) {
              <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a number of Concurrent Uses.</div>
            }
            @if (!Resource.exclusive) {
              <div class="field mb-4 col-12" >
                <label for="MaxConcurrent" class="font-medium">Maximum uses of this resource at the same time (0 is unlimited)</label>
                <p-inputnumber id="MaxConcurrent" [style]="{'width': '300px'}" [(ngModel)]="Resource.maxConcurrent" [showButtons]="true" max="100000" min="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
              </div>
            }
            <div class="field mb-4 col-12">
              <label for="useclasses" class="font-medium">Use Classes</label>
              <p-selectbutton id="useclasses" [style]="{'width': '150px'}" [options]="stateOptions" [(ngModel)]="Resource.useClasses" ></p-selectbutton>
            </div>
            @if (Resource.useClasses) {
              <div class="surface-card p-4 shadow-2 border-round" style="margin-bottom:20px;">
                <p-table [value]="Resource.classes">
                  <ng-template #header>
                    <tr style="color:Black;background-color:White;font-weight:bold;">
                      <th scope="col">Class Name</th>
                      <th scope="col">Capacity</th>
                    </tr>
                  </ng-template>
                  <ng-template #body let-data>
                    <tr >
                      <td>{{data.name}}</td>
                      <td>
                        <p-inputnumber id="length" [showButtons]="true" max="{{Resource.concurrentUses}}" min="0" [(ngModel)]="data.capacity" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            }
            <div class="field mb-4 col-12">
              <label for="colour" class="font-medium">Colour</label><br/>
              <p-colorpicker [style]="{'margin-right': '10px'}" [inline]="false" id="colour" [(ngModel)]="Resource.colour"></p-colorpicker>
              <input style="width:200px;" [(ngModel)]="Resource.colour" id="hexcolour" type="text" pInputText>
            </div>
            <div class="surface-card p-4 shadow-2 border-round" style="width:100%;float:left;">
              <div class="field mb-4 col-12">
                <label for="" class="font-medium">Tags</label>
                <br />
                <p-multiselect [options]="tags" optionLabel="name" [(ngModel)]="Resource.tags" display="chip">
                  <ng-template let-value #selecteditems>
                    @for (tag of Resource.tags; track tag) {
                      <span>
                        <p-chip class="mr-2" label="{{tag.name}}" [style]="{'background': tag.colour, 'color': 'white', 'border-radius': '5px' }"></p-chip>
                      </span>
                    }
                    @if (!Resource.tags || Resource.tags.length === 0) {
                      <div class="country-placeholder"> Select Tag(s) </div>
                    }
                  </ng-template>
                </p-multiselect>
              </div>
            </div>
          </app-tabpanel>
          <app-tabpanel header="Add Resources" leftIcon="pi pi-sitemap" [disabled]="!Resource.isresourcecontainer">
            <div class="surface-card p-4 shadow-2 border-round" style="width:100%;float:left;">
              @if (!isMobile) {
                <div style="float:left; width:32%">
                  <div class="drag-column">
                    <h5> Available Resources </h5>
                    <p-table [value]="allresources">
                      <ng-template #header>
                        <tr>
                          <th style="width:80%">Name</th>
                          <th>&nbsp;</th>
                        </tr>
                      </ng-template>
                      <ng-template #body let-resource>
                        <tr>
                          <td>{{resource.name}}</td>
                          <td>
                            <button pButton pRipple type="button" class="p-button-sm p-element p-button-success w-auto mt-3" (click)="AddToResources(resource)">
                              <span class="pi pi-angle-right"></span>
                            </button>
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>
                    <!--<div *ngIf="availableResources.length == 0" style="padding: 15px;">
                    <i>No resources available</i>
                  </div>-->
                </div>
              </div>
            }
            <div class="cf-col" style="float:right; width:65%">
              <div class="drop-column">
                <!-- On a phone the Available list is this dropdown instead - see addPicked. -->
                @if (isMobile) {
                  <div class="cf-add-row">
                    <p-select [options]="allresources" [(ngModel)]="picked['resources']" [ngModelOptions]="{standalone: true}" optionLabel="name" placeholder="Add a resource"
                    [filter]="true" filterBy="name" appendTo="body" emptyMessage="None available"></p-select>
                    <button pButton pRipple type="button" class="p-button-success"
                      [disabled]="picked['resources'] == null" (click)="addPicked('resources', AddToResources)"><span class="p-button-icon p-button-icon-left pi pi-plus" aria-hidden="true"></span><span class="p-button-label">Add</span></button>
                    </div>
                  }
                  <h5> Selected Resources </h5>
                  @if (!resourceContainerValid) {
                    <div class="text-danger" style="margin-bottom:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must select at least one resource for this container.</div>
                  }
                  <p-table [value]="Resource.resources">
                    <ng-template #header let-columns>
                      <tr>
                        <th>&nbsp;</th>
                        <th style="width:80%">Name</th>
                        <th>Exclusive</th>
                        <th>&nbsp;</th>
                        <th class="row-move-cell"></th>
                      </tr>
                    </ng-template>
                    <ng-template #body let-resource let-columns="columns" let-index="rowIndex">
                      <tr [pReorderableRow]="index">
                        <td>
                          <span class="pi pi-bars" pReorderableRowHandle></span>
                        </td>
                        <td>{{resource.name}}</td>
                        <td>
                          <p-selectbutton [style]="{'width': '225px'}" [options]="stateOptionsRes" [(ngModel)]="resource.exclusive"></p-selectbutton>
                        </td>
                        <td>
                          <button pButton pRipple type="button" [style]="{'margin-bottom': '-6px', 'margin-top': '-4px !important'}" class="p-button-sm p-element p-button-danger w-auto mt-3" (click)="removeFromResources(resource)">
                            <span class="pi pi-angle-left"></span>
                          </button>
                        </td>
                        <td class="row-move-cell"><app-row-move [list]="Resource.resources" [index]="index"></app-row-move></td>
                      </tr>
                    </ng-template>
                  </p-table>
                  <!---<div *ngIf="selectedResources" style="padding: 15px;">
                  <i>No resources selected, drag some here.</i>
                </div>-->
              </div>
            </div>
          </div>
        </app-tabpanel>
      </app-tabview>
      <div class="col-12">
        <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="updateData();">
          <span class="pi pi-pencil" style="margin-right:8px;"></span>
        Save Changes</button>
        &nbsp;
        <button pButton pRipple type="button" class="p-button p-element p-button-danger w-auto mt-3" (click)="returnToList()">
          <span class="pi pi-times" style="margin-right:8px;"></span>
        Cancel</button>
      </div>
    </div>
  </div>
</div>
</div>
}